import React, { useLayoutEffect } from 'react'
import styled from 'styled-components'
import LineaSVG from '../assets/images/LineaCurvaPoliticaPrivacidad.svg'
import LineaMobileSVG from '../assets/images/LineaCurvaMobilePoliticaPrivacidad.svg'
import { sizes } from '../utils/breakpoints'
import { useMediaQuery } from 'react-responsive'
import Seo from '../components/Seo'

const PoliticaPrivacidad = () => {
  const isMobile = useMediaQuery({ maxWidth: sizes.mobile })
  const linea = isMobile ? LineaMobileSVG : LineaSVG

  useLayoutEffect(() => {
    window.scrollTo(0, 0)
  }, [])

  return (
    <Container>
      <Seo
        title="Política de Privacidad"
        description="Política de privacidad de TARTIS: cómo tratamos y protegemos tus datos personales."
        path="/politica-privacidad"
      />
      <Title>Política de Privacidad</Title>
      <ImgLinea src={linea} alt="" />
      <SectionInfo>
        <TitleSection>1. Introducción</TitleSection>
        <InfoSection>
          En TARTIS, nos comprometemos a proteger y respetar tu privacidad. Esta
          Política de Privacidad describe cómo recopilamos, usamos y protegemos
          tus datos personales, así como los derechos que tienes en relación con
          los mismos. Al usar nuestro sitio web, aceptas esta Política de
          Privacidad.
        </InfoSection>
      </SectionInfo>

      <SectionInfo>
        <TitleSection>2. Datos que recopilamos</TitleSection>
        <InfoSection>Recopilamos los siguientes datos personales:</InfoSection>
        <ContainerList>
          <ListInfo>Nombre.</ListInfo>
          <ListInfo>Correo electrónico.</ListInfo>
          <ListInfo>Teléfono.</ListInfo>
        </ContainerList>
      </SectionInfo>

      <SectionInfo>
        <TitleSection>3. Finalidad del tratamiento de los datos</TitleSection>
        <InfoSection>
          Los datos personales que recopilamos tienen como único objetivo
          establecer contacto contigo para responder a tus consultas,
          solicitudes de información o cualquier otro motivo relacionado con los
          servicios que ofrecemos.
        </InfoSection>
      </SectionInfo>

      <SectionInfo>
        <TitleSection>4. Base legal para el tratamiento</TitleSection>
        <InfoSection>
          Tratamos tus datos personales únicamente con tu consentimiento
          explícito, el cual otorgas al proporcionarnos tus datos a través de
          los formularios de contacto o cualquier otro medio disponible en
          nuestro sitio web.
        </InfoSection>
      </SectionInfo>

      <SectionInfo>
        <TitleSection>5. Conservación de los datos</TitleSection>
        <InfoSection>
          Los datos personales proporcionados serán conservados únicamente
          durante el tiempo necesario para cumplir con la finalidad por la que
          fueron recopilados. Una vez cumplido dicho propósito, se eliminarán de
          forma segura, salvo que exista una obligación legal de conservarlos
          por más tiempo.
        </InfoSection>
      </SectionInfo>

      <SectionInfo>
        <TitleSection>6. Conservación de los datos</TitleSection>
        <InfoSection>Derechos de los usuarios</InfoSection>
        <ContainerList>
          <ListInfo>Acceder a tus datos personales.</ListInfo>
          <ListInfo>Rectificar datos incorrectos o incompletos.</ListInfo>
          <ListInfo>
            Solicitar la eliminación de tus datos cuando ya no sean necesarios
            para los fines recogidos.
          </ListInfo>
          <ListInfo>Oponerse al tratamiento de tus datos.</ListInfo>
          <ListInfo>Solicitar la limitación del tratamiento.</ListInfo>
          <ListInfo>
            Portar tus datos a otro responsable del tratamiento.
          </ListInfo>
        </ContainerList>
        <InfoSection>
          Para ejercer cualquiera de estos derechos, puedes contactarnos en
          <Mail href="mailto:info@tartis.io"> info@tartis.io</Mail>.
        </InfoSection>
      </SectionInfo>

      <SectionInfo>
        <TitleSection>7. Seguridad de los datos</TitleSection>
        <InfoSection>
          Nos tomamos muy en serio la seguridad de tus datos personales.
          Implementamos medidas técnicas y organizativas adecuadas para
          protegerlos contra accesos no autorizados, pérdida, destrucción o
          alteración.
        </InfoSection>
      </SectionInfo>

      <SectionInfo>
        <TitleSection>8. Uso de cookies</TitleSection>
        <InfoSection>
          Este sitio web no utiliza cookies para recopilar ni almacenar
          información personal de los usuarios.
        </InfoSection>
      </SectionInfo>

      <SectionInfo>
        <TitleSection>9. Contacto</TitleSection>
        <InfoSection>
          Si tienes preguntas sobre esta Política de Privacidad o deseas ejercer
          tus derechos, puedes ponerte en contacto con nosotros enviando un
          correo electrónico a
          <Mail href="mailto:info@tartis.io"> info@tartis.io</Mail>.
        </InfoSection>
      </SectionInfo>

      <SectionInfo>
        <TitleSection>10. Actualización de esta Política</TitleSection>
        <InfoSection>
          Esta Política de Privacidad puede ser actualizada para reflejar
          cambios en nuestras prácticas, servicios o en la legislación
          aplicable. Cualquier modificación será publicada en nuestro sitio web,
          y será aplicable desde su fecha de publicación.
        </InfoSection>
      </SectionInfo>
    </Container>
  )
}

export default PoliticaPrivacidad

const Container = styled.div`
  margin-bottom: 70px;
`

const Title = styled.h1`
  padding: 158px 0 0 230px;
  font-family: ${({ theme }) => theme.fonts.heading};
  font-size: 40px;
  line-height: 48px;
  color: ${({ theme }) => theme.colors.text.primary};

  @media (max-width: ${sizes.mobile}px) {
    padding: 70px 0 0 30px;
    font-size: 15px;
    line-height: 18px;
  }
`

const ImgLinea = styled.img`
  width: 100%;
  max-width: 100%;
  height: auto;
`

const SectionInfo = styled.div`
  padding: 50px 293px 0 230px;
  margin-bottom: 30px;
  @media (max-width: ${sizes.mobile}px) {
    padding: 20px 40px 0 30px;
  }
`

const TitleSection = styled.p`
  font-family: 'fuenteNegrita';
  font-size: 24px;
  line-height: 28.8px;

  @media (max-width: ${sizes.mobile}px) {
    font-size: 13px;
    line-height: 15.6px;
  }
`
const InfoSection = styled.span`
  font-family: 'fuenteRegularMont';
  font-size: 20px;
  line-height: 24.38px;

  @media (max-width: ${sizes.mobile}px) {
    font-size: 12px;
    line-height: 14.63px;
  }
`

const ListInfo = styled.li`
  font-family: 'fuenteRegularMont';
  font-size: 20px;
  line-height: 24.38px;
  margin-bottom: 5px;

  &::marker {
    font-size: 0.7em; /* Ajusta el tamaño del marcador */
  }

  @media (max-width: ${sizes.mobile}px) {
    font-size: 12px;
    line-height: 14.63px;
  }
`

const ContainerList = styled.div`
  margin-top: 20px;
  margin-bottom: 20px;
  padding-left: 5px;
`

const Mail = styled.a`
  font-family: 'fuenteNegritaMont';
  color: inherit;
  text-decoration: none;
`
